import {
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output
} from '@angular/core';
import Order from 'src/app/models/Order';
import {OrderPool} from 'src/app/models/OrderPool';
import {STATUS_CHANGE} from 'src/app/services/order.service';
import {PrinterService} from '../../../services/printer.service';
import {Venue} from '../../../models/Venue';
import {
	checkIfManualAcceptedView,
	groupOptionsByGroup,
	isUber,
	isWolt
} from '../manager-utils/manager-utils';

@Component({
	selector: 'app-manager-order-item-draw',
	templateUrl: './manager-order-item-draw.component.html',
	styleUrls: ['./manager-order-item-draw.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ManagerOrderItemDrawComponent implements OnInit {
	orderValue: Order | OrderPool;
	@Input() set order(value: Order | OrderPool) {
		this.orderValue = value;
	}
	@Input() venue: Venue | null;
	@Output() sendOrderStatusChange = new EventEmitter<{
		order: Order;
		status: STATUS_CHANGE;
	}>();

	printerConnected = this.printerService.isConnectedObservable;

	constructor(
		private printerService: PrinterService,
		private el: ElementRef
	) {
		console.log(this.printerService);
	}
	@Output() sendOrderPoolStatusChange = new EventEmitter<{
		orderPool: OrderPool;
		status: STATUS_CHANGE;
	}>();
	@Input() updateStatusLoading: boolean | null;
	public selectedOrderId: string = '';

	ngOnInit() {}
	updateStatus(data: {order: Order; status: STATUS_CHANGE}) {
		this.sendOrderStatusChange.emit(data);
	}

	printOrder(order: Order, venue: Venue) {
		order.orderedArticles = order.orderedArticles.map(it => {
			return {...it, groupsForRender: groupOptionsByGroup(it.groups)};
		});
		this.printerService
			.print(order, venue)
			.then(result => {
				console.log('Printing successfully', result);
			})
			.catch(error => {
				console.error(error);
			});
	}
	sendStatusOrderPoolFunc(data: {orderPool: OrderPool; status: STATUS_CHANGE}) {
		console.log('DATA', data);
		this.sendOrderPoolStatusChange.emit(data);
	}
	checkIfOrder(value: Order | OrderPool): value is Order {
		return (value as Order)?.orderedArticles != undefined;
	}
	checkIfOrderPool(value: Order | OrderPool): value is OrderPool {
		return (
			(value as OrderPool)?.dndCompany != undefined &&
			(value as OrderPool)?.orders != undefined
		);
	}
	emitSelectOrderToShow(event: {orderId: string}) {
		console.log(event.orderId);
		this.selectedOrderId = event.orderId;
		this.scrollToOrder(event.orderId);
	}
	scrollToOrder(orderId: string) {
		const element = this.el.nativeElement.querySelector(`#order-${orderId}`);
		if (element) {
			element.scrollIntoView({behavior: 'smooth', block: 'start'});
		}
	}

	getBackgroundColor(
		order: Order | OrderPool,
		venue: Venue | null
	): string | null {
		if (!order || !venue) return null;
		if (!checkIfManualAcceptedView(order, venue)) {
			return null;
		}
		if (this.checkIfOrderPool(order)) {
			return null;
		}

		if (isWolt(order)) {
			return '#00C2E8';
		}

		if (isUber(order)) {
			return '#3FC060';
		}

		return null;
	}
}
